import { usersEndpoints } from "@omega/omp-api";
import type { RequestConfig } from "@app/config/axios/http";
import { ompTransport } from "@src/api/ompTransport";
import type { ApiCurrentUser, ApiUserGroup, ApiUserGroupFilter, ApiUserListFilter, ApiUserListItem } from "./types";

/**
 * Транспортный слой OMP — пользователи и текущая сессия.
 * Контракты и wire-формат — из пакета `@omega/omp-api`.
 */
export const usersApi = {
    /**
     * Возвращает краткие данные текущего авторизованного пользователя.
     * Запрос уходит в endpoint `user.getCurrentUser`.
     * @param config конфигурация HTTP-запроса
     * @returns данные текущего пользователя
     */
    loadCurrent: async (config?: RequestConfig): Promise<ApiCurrentUser> => {
        return usersEndpoints.getCurrentUser.call(ompTransport, {}, config);
    },

    /**
     * Загружает пользователей OMP по фильтру. \
     * Универсальный endpoint `user.loadListByFilter` — основной способ получить пользователя по `Codes`.
     * @param flt фильтр пользователей
     * @param config конфигурация HTTP-запроса
     */
    loadListByFilter: async (flt: ApiUserListFilter, config?: RequestConfig): Promise<ApiUserListItem[]> => {
        return usersEndpoints.loadListByFilter.call(ompTransport, flt, config);
    },

    /**
     * Загружает группы пользователей по фильтру.
     * Запрос уходит в endpoint `user.loadGroupByFilter`.
     * @param flt фильтр групп
     * @param config конфигурация HTTP-запроса
     */
    loadGroupsByFilter: async (flt: ApiUserGroupFilter, config?: RequestConfig): Promise<ApiUserGroup[]> => {
        return usersEndpoints.loadGroupByFilter.call(ompTransport, flt, config);
    },
} as const;
